var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.displayPolarisEdit && !_vm.displayPolarisView
    ? _c(
        "div",
        { staticClass: "go-detail-content", attrs: { id: "contentToPrint" } },
        [
          _vm.loading && _vm.reportType === "SOCIAL_MEDIA"
            ? _c(
                "div",
                { staticClass: "go-detail-report go-report-template-02" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "go-detail-header go-report-cover go-report-cover-style-02",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "go-block-top",
                          on: {
                            click: function ($event) {
                              return _vm.selectBody(
                                undefined,
                                undefined,
                                undefined
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "go-block-center" }, [
                            _c("span", { staticClass: "go-report-category" }, [
                              _vm._v(_vm._s(_vm.$t("report.social-media"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("h1", { staticClass: "go-report-title" }, [
                            _vm._v(_vm._s(_vm.dataHeading.data.title.content)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-block-center" }, [
                            _c("ul", { staticClass: "go-info-inline" }, [
                              _c(
                                "li",
                                { staticClass: "go-info-item go-datetime" },
                                [
                                  _vm.getSelectedResource.privateType ===
                                  "PRIVATE"
                                    ? _c(
                                        "span",
                                        { staticClass: "go-private-thumb" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-18 go-icon-private",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("em", { staticClass: "go-text" }, [
                                    _vm._v(
                                      _vm._s(_vm.dataHeading.data.date.content)
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-block-body" }, [
                        _vm.dataHeading.data.title_image.content
                          ? _c("div", { staticClass: "go-report-img" }, [
                              _c("img", {
                                attrs: {
                                  loading: "lazy",
                                  src: _vm.dataHeading.data.title_image.content,
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "go-detail-body go-report-contents" },
                    [
                      _vm._l(_vm.dataBody.slice(0, 2), function (model, index) {
                        return _c("body-component", {
                          key: index,
                          attrs: {
                            option: model,
                            componentSelect: _vm.selectedComponent,
                            index: index,
                            bodyLength: _vm.dataBody && _vm.dataBody.length,
                            selectedHeading: _vm.selectedIndex,
                            detailReport: _vm.detailReport,
                            reportType: _vm.reportType,
                          },
                          on: {
                            selectBody: _vm.selectBody,
                            updateSelectedIndex: _vm.updateSelectedIndex,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.dataBody.slice(2), function (model, index) {
                        return _c("body-component", {
                          key: index + 2,
                          attrs: {
                            option: model,
                            componentSelect: _vm.selectedComponent,
                            index: index + 2,
                            bodyLength: _vm.dataBody && _vm.dataBody.length,
                            selectedHeading: _vm.selectedIndex,
                            detailReport: _vm.detailReport,
                            reportType: _vm.reportType,
                          },
                          on: {
                            selectBody: _vm.selectBody,
                            updateSelectedIndex: _vm.updateSelectedIndex,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _c("reference-component", {
                        attrs: {
                          option: _vm.dataReference,
                          index: (_vm.dataBody && _vm.dataBody.length) || 0,
                          componentSelect: _vm.selectedComponent,
                        },
                        on: { selectBody: _vm.selectBody },
                      }),
                      _vm._v(" "),
                      _c("report-footer"),
                    ],
                    2
                  ),
                ]
              )
            : _vm.loading && _vm.reportType === "INDEPTH_DAILY"
            ? _c(
                "div",
                { staticClass: "go-detail-report go-report-template-in-depth" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "go-detail-header go-report-cover go-report-cover-style-in-depth",
                    },
                    [
                      _c("div", { staticClass: "go-block-body" }, [
                        _vm.dataHeading.data.title_image.content
                          ? _c("div", { staticClass: "go-report-img" }, [
                              _c("img", {
                                attrs: {
                                  loading: "lazy",
                                  src: _vm.dataHeading.data.title_image.content,
                                },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-block-text" }, [
                          _c("span", { staticClass: "go-report-category" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dataHeading.data.publisher.content) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("h1", { staticClass: "go-report-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dataHeading.data.title.content) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "no-class" }, [
                            _c("span", {
                              staticClass: "go-report-datetime",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.dataHeading.data.date.content
                                ),
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-report-madeby" }, [
                            _c("img", {
                              attrs: {
                                loading: "lazy",
                                src: _vm.logo,
                                alt: "goover",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.getSelectedResource.privateType === "PRIVATE"
                            ? _c(
                                "div",
                                { staticClass: "go-btn-icon report-private" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          value: { customClass: "go-tooltip" },
                                          expression:
                                            "{ customClass: 'go-tooltip' }",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: "Private" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-private",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "go-detail-body go-report-contents" },
                    [
                      _vm.dataTableOfContent &&
                      _vm.dataTableOfContent.data &&
                      _vm.dataTableOfContent.data.table_of_entry.length
                        ? _c("div", { staticClass: "go-report-section" }, [
                            _c("div", { staticClass: "inner-box" }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    _vm.selectedComponent ===
                                    _vm.dataTableOfContent.component
                                      ? "go-report-section"
                                      : "",
                                    "go-report-toc  go-report-section-index",
                                  ],
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dataTableOfContent.data
                                          .table_of_section.content
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "go-report-toc-list" },
                                    _vm._l(
                                      _vm.dataTableOfContent.data
                                        .table_of_entry,
                                      function (model, index) {
                                        return _c("li", { key: index }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(model.content) +
                                              "\n              "
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.dataBody, function (model, index) {
                        return _c("body-component", {
                          key: index,
                          attrs: {
                            option: model,
                            componentSelect: _vm.selectedComponent,
                            index: index,
                            bodyLength: _vm.dataBody && _vm.dataBody.length,
                            selectedHeading: _vm.selectedIndex,
                            detailReport: _vm.detailReport,
                            reportType: _vm.reportType,
                          },
                          on: {
                            selectBody: _vm.selectBody,
                            updateSelectedIndex: _vm.updateSelectedIndex,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _c("reference-component", {
                        attrs: {
                          option: _vm.dataReference,
                          index: (_vm.dataBody && _vm.dataBody.length) || 0,
                          componentSelect: _vm.selectedComponent,
                        },
                        on: { selectBody: _vm.selectBody },
                      }),
                      _vm._v(" "),
                      _c("report-footer"),
                    ],
                    2
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "go-detail-report go-report-template-01",
                  staticStyle: { "min-height": "0 !important" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "go-detail-header go-report-cover go-report-cover-style-01",
                      on: {
                        click: function ($event) {
                          return _vm.selectBody(undefined, undefined, undefined)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "go-block-body" }, [
                        _c("div", { staticClass: "go-report-image" }, [
                          _c("figure", [
                            _c("img", {
                              ref: "imageRef",
                              style: _vm.imageStyle(),
                              attrs: {
                                loading: "lazy",
                                src: _vm.dataHeading.data.title_image.content,
                                alt: "Alternate Image",
                              },
                              on: {
                                error: function ($event) {
                                  _vm.dataHeading.data.title_image.content =
                                    "https://goover.ai/thumbnail/insight-cover/def78006-f92b-47ea-8e5e-7fad428b9f78.png"
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-block-text" }, [
                          _c("span", { staticClass: "go-report-category" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dataHeading.data.publisher.content) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("h1", { staticClass: "go-report-title" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dataHeading.data.title.content) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "no-class" }, [
                            _c(
                              "span",
                              {
                                staticClass: "go-report-datetime",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.dataHeading.data.date.content
                                  ),
                                },
                              },
                              [_vm._v("11/15/2023")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-report-madeby" }, [
                            _c("img", {
                              attrs: {
                                loading: "lazy",
                                src: _vm.logo,
                                alt: "goover",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _vm.getSelectedResource.privateType === "PRIVATE"
                            ? _c(
                                "div",
                                { staticClass: "go-btn-icon report-private" },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover.top",
                                          value: { customClass: "go-tooltip" },
                                          expression:
                                            "{ customClass: 'go-tooltip' }",
                                          modifiers: { hover: true, top: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: "Private" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-private",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "go-detail-body go-report-contents" },
                    [
                      _vm.dataTableOfContent &&
                      _vm.dataTableOfContent.data &&
                      _vm.dataTableOfContent.data.table_of_entry.length
                        ? _c("div", { staticClass: "go-report-section" }, [
                            _c("div", { staticClass: "inner-box" }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    _vm.selectedComponent ===
                                    _vm.dataTableOfContent.component
                                      ? "go-report-section"
                                      : "",
                                    "go-report-toc  go-report-section-index",
                                  ],
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dataTableOfContent.data
                                          .table_of_section.content
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ol",
                                    { staticClass: "go-report-toc-list" },
                                    _vm._l(
                                      _vm.dataTableOfContent.data
                                        .table_of_entry,
                                      function (model, index) {
                                        return _c("li", { key: index }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(model.content) +
                                              "\n              "
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.dataBody.slice(0, 2), function (model, index) {
                        return _c("body-component", {
                          key: index,
                          attrs: {
                            option: model,
                            componentSelect: _vm.selectedComponent,
                            index: index,
                            bodyLength: _vm.dataBody && _vm.dataBody.length,
                            selectedHeading: _vm.selectedIndex,
                            detailReport: _vm.detailReport,
                            reportType: _vm.reportType,
                          },
                          on: {
                            selectBody: _vm.selectBody,
                            updateSelectedIndex: _vm.updateSelectedIndex,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.dataBody.slice(2), function (model, index) {
                        return _c("body-component", {
                          key: index + 2,
                          attrs: {
                            option: model,
                            componentSelect: _vm.selectedComponent,
                            index: index + 2,
                            bodyLength: _vm.dataBody && _vm.dataBody.length,
                            selectedHeading: _vm.selectedIndex,
                            detailReport: _vm.detailReport,
                            reportType: _vm.reportType,
                          },
                          on: {
                            selectBody: _vm.selectBody,
                            updateSelectedIndex: _vm.updateSelectedIndex,
                          },
                        })
                      }),
                      _vm._v(" "),
                      _c("reference-component", {
                        attrs: {
                          option: _vm.dataReference,
                          index: (_vm.dataBody && _vm.dataBody.length) || 0,
                          componentSelect: _vm.selectedComponent,
                        },
                        on: { selectBody: _vm.selectBody },
                      }),
                      _vm._v(" "),
                      _c("report-footer"),
                    ],
                    2
                  ),
                ]
              ),
          _vm._v(" "),
          _vm.getSelectedResource
            ? [
                _c("ReportComments", {
                  attrs: { data: _vm.getSelectedResource },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.articleRelatedPeople &&
          _vm.articleRelatedPeople.length &&
          _vm.articleRelatedDocument &&
          _vm.articleRelatedDocument.length
            ? _c("reportRelated", {
                attrs: {
                  relatedPeople: _vm.articleRelatedPeople,
                  relatedDocument: _vm.articleRelatedDocument,
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }